import { EditorDefns } from "aic";
import {
  getTextFromEditorV3,
  IEditorV3,
  joinV3intoBlock,
  replaceTextInEditorV3,
  splitV3intoLines,
  stringToV3,
} from "editor-v3";
import { EditorV3Wrapper } from "./EditorV3Wrapper";

export const v3EditorProps: EditorDefns<IEditorV3> = {
  Editor: EditorV3Wrapper,
  getTextFromT: getTextFromEditorV3,
  replaceTextInT: replaceTextInEditorV3,
  blankT: stringToV3(""),
  joinTintoBlock: joinV3intoBlock,
  splitTintoLines: splitV3intoLines,
  textToT: stringToV3,
};
